import "./Actions.css";
import Action from "./Action";
import Refresh from "../icons/refresh";
import Download from "../icons/download";
import Copy from "../icons/copy";

const EXPORT_BUTTONS = {
  png: { label: "PNG", icon: <Download /> },
  svg: { label: "SVG", icon: <Download /> },
  url: { label: "URL", icon: <Copy /> },
  copy: { label: "Copy", icon: <Copy /> },
  webm: { label: "WEBM", icon: <Download /> },
};

const Actions = ({ onExport, onRefresh, exportOptions, exportState }) => {
  const isExporting = exportState !== null;

  return (
    <div className="Actions">
      <div className="Actions__Refresh">
        <Action
          title="Refresh"
          icon={<Refresh />}
          onClick={onRefresh}
          disabled={isExporting}
        />
      </div>
      <div className="Actions__Export">
        {exportOptions.map((type) => {
          const btn = EXPORT_BUTTONS[type];
          if (!btn) return null;
          const isActive = exportState?.type === type;
          // WEBM shows a live countdown; other active actions keep their label
          const title =
            isActive && exportState?.remaining !== undefined
              ? `${exportState.remaining}s`
              : btn.label;
          return (
            <Action
              key={type}
              title={title}
              icon={btn.icon}
              onClick={() => onExport(type)}
              loading={isActive}
              disabled={isExporting && !isActive}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Actions;
